import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Nav from './nav/Nav';
import { CreditCardTracker, Kingpin, CiscoIntern, ComparedToWhat, HEM } from './pages/index.js';
import './index.css';
import './App.css';

const App = () => {
  useEffect(() => {
    document.title = 'moreminttea'
  }, []);

  return (
    <div className='App'>
      <BrowserRouter basename='/'>
        <Routes>
          <Route exact path='/' element={<Nav />} />
          <Route path='/credit-card-tracker' element={<CreditCardTracker />} />
          <Route path='/kingpin' element={<Kingpin />} />
          <Route path='/cisco-intern' element={<CiscoIntern />} />
          <Route path='/compared-to-what' element={<ComparedToWhat />} />
          <Route path='/hem' element={<HEM />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;